export { coreDetailsTab } from "./CoreDetails";
